var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page-create"},[_c('ScenePadCreator',{on:{"play":_vm.Handle_OnPlay}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }